
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';

export default function Products() {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const navigate = useNavigate();

  const mainCategories = [
    {
      id: 'cıvatalar',
      name: 'Cıvatalar',
      description: 'DIN/ISO standartlarında cıvata çeşitleri',
      image: 'https://static.readdy.ai/image/9303f61569a9465cee12a440b79150b6/77c208eb7f186b180289a290016e4ce7.jpeg',
      subCategories: [
        {
          id: 'imbus-civatalar',
          name: 'İmbus Cıvatalar',
          description: 'Allen başlı silindir cıvatalar',
          image: 'https://static.readdy.ai/image/9303f61569a9465cee12a440b79150b6/eafcab84e3b708a8632aab98662b7571.png',
          products: [
            'DIN 912 - İmbus Cıvata',
            'DIN 7380 - Bombe Başlı İmbus Cıvata',
            'DIN 7984 - İnce Kafa İmbus Cıvata',
            'DIN 7991 - Havşa Baş İmbus Cıvata'
          ]
        },
        {
          id: 'akb-civatalar',
          name: 'AKB Cıvatalar',
          description: 'Altı köşe başlı cıvatalar',
          image: 'https://static.readdy.ai/image/9303f61569a9465cee12a440b79150b6/77c208eb7f186b180289a290016e4ce7.jpeg',
          products: [
            'DIN 933 - Altı Köşe Tam Diş Cıvata',
            'DIN 931 - Altı Köşe Yarım Diş Cıvata',
            'DIN 960 - Altı Köşe İnce Diş Yarım Diş Cıvata',
            'DIN 961 - Altı Köşe İnce Diş Tam Diş Cıvata'
          ]
        },
        {
          id: 'setskurlar',
          name: 'Setskurlar',
          description: 'Sabitleme ve pozisyonlama cıvataları',
          image: 'https://static.readdy.ai/image/9303f61569a9465cee12a440b79150b6/127f0e7f636a6711bb04d5da23fd52fd.webp',
          products: [
            'DIN 914 - Sivri Uçlu Setskur',
            'DIN 915 - Bilye Uçlu Setskur',
            'DIN 916 - Düz Uçlu Setskur',
            'DIN 913 - Düz Uçlu Setskur'
          ]
        },
        {
          id: 'diger-civatalar',
          name: 'Diğer',
          description: 'Özel amaçlı cıvatalar',
          image: 'https://readdy.ai/api/search-image?query=Special%20purpose%20bolts%20and%20fasteners%20including%20wing%20bolts%20eye%20bolts%20and%20custom%20designed%20bolts%20on%20dark%20industrial%20surface%2C%20professional%20photography%20showing%20variety%20of%20specialized%20fastening%20solutions&width=400&height=300&seq=diger-civata&orientation=landscape',
          products: [
            'DIN 316 - Kelebek Başlı Cıvata',
            'DIN 444 - Gözlü Cıvata',
            'DIN 603 - Yuvarlak Başlı Dibi Dört Köşe Cıvata',
            'DIN 571 - Altı Köşe Başlı Ağaç Vidası'
          ]
        }
      ]
    },

    {
      id: 'somunlar',
      name: 'Somunlar',
      description: 'Hassas işlenmiş somun çeşitleri',
      image: 'https://readdy.ai/api/search-image?query=Luxury%20precision%20machined%20hex%20nuts%20displayed%20on%20polished%20dark%20granite%20surface%2C%20professional%20studio%20photography%20with%20elegant%20lighting%2C%20high-end%20industrial%20fasteners%20with%20perfect%20finish%2C%20sophisticated%20composition%20highlighting%20engineering%20precision%20and%20quality%20manufacturing%20excellence&width=400&height=300&seq=premium-nuts&orientation=landscape',
      subCategories: [
        {
          id: 'standart-somunlar',
          name: 'Standart Somunlar',
          description: 'Genel amaçlı somunlar',
          image: 'https://readdy.ai/api/search-image?query=Standard%20hex%20nuts%20arranged%20systematically%20on%20dark%20industrial%20surface%2C%20professional%20product%20photography%20showing%20six-sided%20design%20and%20internal%20threading%2C%20various%20sizes%20with%20galvanized%20finish&width=400&height=300&seq=standart-somart&orientation=landscape',
          products: [
            'DIN 934 - Altı Köşe Somun',
            'DIN 439-2 - Altı Köşe Kontra Somun',
            'DIN 936 - Altı Köşe Kontra Somun',
            'DIN 1587 - Altı Köşe Kör Somun'
          ]
        },
        {
          id: 'ozel-somunlar',
          name: 'Özel Somunlar',
          description: 'Özel amaçlı somun çeşitleri',
          image: 'https://readdy.ai/api/search-image?query=Special%20nuts%20including%20wing%20nuts%20lock%20nuts%20and%20flanged%20nuts%20on%20dark%20metallic%20surface%2C%20professional%20photography%20showing%20various%20specialized%20nut%20designs%20for%20specific%20applications&width=400&height=300&seq=ozel-somun&orientation=landscape',
          products: [
            'DIN 315 - Kelebek Somun',
            'DIN 985 - Altı Köşe Fiberli Somun',
            'DIN 6923 - Altı Köşe Flanşlı Somun',
            'DIN 6334 - Altı Köşe Uzatma Somunu'
          ]
        }
      ]
    },
    {
      id: 'vidalar',
      name: 'Vidalar',
      description: 'Kendinden dişli ve ağaç vidaları',
      image: 'https://static.readdy.ai/image/9303f61569a9465cee12a440b79150b6/5065157be2a1b07f8c33cf1adabd80ed.jpeg',
      subCategories: [
        {
          id: 'metrik-vidalar',
          name: 'Metrik Vidalar',
          description: 'Metrik diş sistemli vidalar',
          image: 'https://static.readdy.ai/image/9303f61569a9465cee12a440b79150b6/0750993e18b74c2d8a1e9cbc6ffce0b7.jpeg',
          products: [
            'DIN 84 - Düz Yarık Silindir Başlı Vida',
            'DIN 963 - Metrik Havşa Başlı Vida',
            'DIN 965 - Yıldız Havşa Başlı Vida',
            'DIN 7985 - Yıldız Silindir Başlı Metrik Vida'
          ]
        },
        {
          id: 'sac-vidalari',
          name: 'Sac Vidaları',
          description: 'Metal sac için kendinden dişli vidalar',
          image: 'https://static.readdy.ai/image/9303f61569a9465cee12a440b79150b6/23bcc818dddfe6ae8936cfa778274b6c.png',
          products: [
            'DIN 7971 - Silindir Başlı Sac Vidası',
            'DIN 7981 - Yıldız Silindir Başlı Sac Vidası',
            'DIN 7982 - Yıldız Havşa Başlı Sac Vidası'
          ]
        },
        {
          id: 'matkap-uclu-vidalar',
          name: 'Matkap Uçlu Vidalar',
          description: 'Kendinden delici vidalar',
          image: 'https://static.readdy.ai/image/9303f61569a9465cee12a440b79150b6/da2faa7efb91f965a0cc4f0b143c843e.jpeg',
          products: [
            'DIN 7504K - Altı Köşe Pul Başlı Matkap Uçlu Vida',
            'DIN 7504N - Yıldız Silindir Başlı Matkap Uçlu Vida',
            'DIN 7504P - Yıldız Havşa Başlı Matkap Uçlu Vida',
            'Poliüretan Panel Vidası',
            'Pulbaşlı M.Uçlu Vida',
            'Matkap Uçlu Alçıpan Vidası',
            'Sıkdişli Alçıpan Vida',
            'Seyrek Dişli Alçıpan Vida',
            'Konteyner Vidası',
            'Küpeşte Vidası',
            'İspanyolet Vidası',
            'Buldeks Vidası',
            'Beton Vidası'
          ]
        },
        {
          id: 'ahsap-vidalari',
          name: 'Ahşap Vidaları',
          description: 'Ahşap uygulamaları için vidalar',
          image: 'https://static.readdy.ai/image/9303f61569a9465cee12a440b79150b6/dc873cc7a46f124394b0ccc7721c0231.jpeg',
          products: [
            'DIN 571 - Altı Köşe Başlı Ağaç Vidası',
            'DIN 7505 - Sunta Vidası',
            'MDF Vidası',
            'CRP Vidası',
            'İspanyolet Vidası'
          ]
        }
      ]
    },
    {
      id: 'rondelalar',
      name: 'Rondelalar',
      description: 'Düz ve yaylı rondela türleri',
      image: 'https://readdy.ai/api/search-image?query=Premium%20washers%20and%20gaskets%20artistically%20arranged%20on%20polished%20dark%20steel%20surface%2C%20professional%20studio%20photography%20with%20dramatic%20lighting%2C%20high-end%20precision%20cut%20washers%20with%20mirror%20finish%2C%20elegant%20composition%20showcasing%20engineering%20precision%20and%20quality%20manufacturing&width=400&height=300&seq=premium-washers&orientation=landscape',
      subCategories: [
        {
          id: 'rondelalar',
          name: 'Rondelalar',
          description: 'Düz ve yaylı rondela çeşitleri',
          image: 'https://readdy.ai/api/search-image?query=Various%20types%20of%20washers%20including%20flat%20washers%20spring%20washers%20and%20lock%20washers%20arranged%20on%20dark%20industrial%20surface%2C%20professional%20product%20photography%20showing%20different%20sizes%20and%20finishes%2C%20stainless%20steel%20and%20zinc%20plated%20washers%20with%20precise%20manufacturing%20quality&width=400&height=300&seq=all-washers&orientation=landscape',
          products: [
            'DIN 125/A - Düz Rondela',
            'DIN 126 - Düz Altı Köşe Başlı Cıvata ve Somunlar İçin Rondela',
            'DIN 127/B - Yaylı Rondela',
            'DIN 128/B - Yaylı Rondela 2',
            'DIN 137/B - Eğri Yaylı Rondela',
            'DIN 434 - Kare Rondela',
            'DIN 435 - Kare Eğimli Rondela',
            'DIN 6796 - Çanak Rondela',
            'DIN 6798/A - Tırtıllı Rondela (Dıştan)',
            'DIN 6916 - Yüksek Mukavemetli Yapısal Rondela',
            'DIN 9021 - Geniş Pul Düz Dış Çap',
            'İnç Yaylı Rondela',
            'İnç Düz Rondela'
          ]
        }
      ]
    }
  ];

  const handleCategoryClick = (category) => {
    if (selectedCategory?.id === category.id) {
      setSelectedCategory(null);
    } else {
      setSelectedCategory(category);
    }
  };

  const handleSubCategoryClick = (mainCategoryId, subCategoryId) => {
    navigate(`/urun-kategori/${mainCategoryId}/${subCategoryId}`);
  };

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section 
          className="relative py-32 bg-cover bg-center"
          style={{
            backgroundImage: `linear-gradient(rgba(15, 23, 42, 0.7), rgba(15, 23, 42, 0.7)), url('https://readdy.ai/api/search-image?query=Industrial%20fasteners%20and%20bolts%20organized%20in%20modern%20manufacturing%20facility%2C%20professional%20product%20display%20with%20various%20steel%20components%2C%20precision%20engineered%20bolts%20nuts%20screws%20and%20washers%2C%20high-tech%20production%20environment%20with%20metallic%20surfaces%20and%20dramatic%20lighting&width=1920&height=600&seq=products-hero&orientation=landscape')`
          }}
        >
          <div className="container mx-auto px-4 text-center text-white">
            <h1 
              className="text-5xl md:text-6xl font-bold mb-6"
              style={{ fontFamily: 'Exo 2, sans-serif' }}
            >
              Ürün Kategorilerimiz
            </h1>
            <p className="text-xl md:text-2xl max-w-3xl mx-auto">
              DIN ve ISO standartlarında kapsamlı bağlantı elemanları yelpazesi
            </p>
          </div>
        </section>

        {/* Main Categories */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {mainCategories.map((category) => (
                <div key={category.id} className="space-y-4">
                  {/* Main Category Card */}
                  <div 
                    className={`bg-gray-50 rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 group cursor-pointer ${
                      selectedCategory?.id === category.id ? 'ring-2 ring-orange-500' : ''
                    }`}
                    onClick={() => handleCategoryClick(category)}
                  >
                    <div className="relative overflow-hidden">
                      <img 
                        src={category.image}
                        alt={category.name}
                        className="w-full h-48 object-cover object-top group-hover:scale-105 transition-transform duration-300"
                      />
                      <div className="absolute inset-0 bg-slate-900/20 group-hover:bg-slate-900/10 transition-colors duration-300"></div>
                      <div className="absolute bottom-4 left-4 right-4">
                        <h3 className="text-xl font-bold text-white mb-1">
                          {category.name}
                        </h3>
                        <p className="text-gray-200 text-sm">
                          {category.description}
                        </p>
                      </div>
                    </div>
                    <div className="p-4 text-center">
                      <div className="flex items-center justify-center text-orange-500">
                        <span className="text-sm font-medium mr-2">Alt Kategorileri Görüntüle</span>
                        <i className={`ri-arrow-${selectedCategory?.id === category.id ? 'up' : 'down'}-s-line`}></i>
                      </div>
                    </div>
                  </div>

                  {/* Sub Categories */}
                  {selectedCategory?.id === category.id && (
                    <div className="space-y-3 animate-fadeIn">
                      {category.subCategories.map((subCategory) => (
                        <div 
                          key={subCategory.id}
                          className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow hover:shadow-md transition-all duration-300 group cursor-pointer"
                          onClick={() => handleSubCategoryClick(category.id, subCategory.id)}
                        >
                          <div className="flex">
                            <div className="w-20 h-20 flex-shrink-0">
                              <img 
                                src={subCategory.image}
                                alt={subCategory.name}
                                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-300"
                              />
                            </div>
                            <div className="flex-1 p-3">
                              <h4 className="font-semibold text-slate-800 mb-1 text-sm">
                                {subCategory.name}
                              </h4>
                              <p className="text-gray-600 text-xs mb-2">
                                {subCategory.description}
                              </p>
                              <div className="text-xs text-orange-500 font-medium">
                                Detayları Görüntüle
                              </div>
                            </div>
                            <div className="flex items-center pr-3">
                              <i className="ri-arrow-right-s-line text-gray-400 group-hover:text-orange-500 transition-colors duration-200"></i>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-20 bg-slate-800 text-white">
          <div className="container mx-auto px-4 text-center">
            <h2 
              className="text-4xl font-bold mb-6"
              style={{ fontFamily: 'Exo 2, sans-serif' }}
            >
              Projeleriniz İçin Doğru Çözüm
            </h2>
            <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
              Endüstriyel bağlantı elemanları ihtiyaçlarınız için bizimle iletişime geçin
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                size="lg" 
                className="w-full sm:w-auto"
                onClick={() => navigate('/iletisim')}
              >
                Teklif Al
              </Button>
              <Button 
                variant="outline" 
                size="lg" 
                className="w-full sm:w-auto"
                onClick={() => navigate('/hakkimizda')}
              >
                Hakkımızda
              </Button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
